import { useStaticQuery, graphql } from "gatsby"

export default function usePlatformBlocks() {
  return useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "0_HOMEPAGE/platform_blocks.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `).file
}
